module.exports = __webpack_public_path__ + "img/samseir.e933957.png";